import * as React from 'react';
import Swipe from 'swipejs';

interface SliderProps {
  setSlideIndex: (index: number) => void;
  instance: React.MutableRefObject<Swipe | null>;
  children: React.ReactNode;
  options?: {
    startSlide?: number;
    stopPropagation?: boolean;
  };
}

function Slider({ setSlideIndex, instance, children, options }: SliderProps): React.ReactElement {
  const sliderElement = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (sliderElement.current) {
      instance.current = new Swipe(sliderElement.current, {
        callback: (index: number): void => setSlideIndex(index),
        ...options
      });
    }
  }, [instance, setSlideIndex, options]);

  return (
    <div className="swipe" ref={sliderElement}>
      <div className="swipe-wrap">{children}</div>
    </div>
  );
}

export default Slider;
